import React, { useState } from 'react';
import Modal from '@app/components/General/Modal'
import Label from '@app/components/General/Label'
import { Button, Row, Col, Input, Select, message } from 'antd';
import { insert } from '../../../../apis/UsersApi';
import { getEmpleados } from '../../../../apis/OdooApi';
import { getAll as getRoles } from '../../../../apis/RolesApi';

const { confirm } = Modal;
const AddUser = ({ id, saveFn }) => {
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState(1);
    const [empleado, setEmpleado] = useState(null);
    const [empleados, setEmpleados] = useState([]);
    const [roles, setRoles] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const handleOk = async () => {
        debugger;
        const payload = {
            first_name: firstName,
            last_name: lastName,
            email,
            password,
            role_id: role,
            empleado_id: empleado
        }
        const response = await insert(payload);
        if (response.ok) {
            message.success('Se guardo correctamente el usuario!');
            setShowModal(false);
        }
    }
    const handleChangeRole = (value) => {
        setRole(value);
    }

    const btnClick = async ()=>{
        setFirstName('');
        setLastName('');
        setEmail('');
        setPassword('');
        setRole(undefined);
        setEmpleado(null);
        setShowModal(true);

        const [empleadosResponse, rolesResponse] = await Promise.all([getEmpleados(), getRoles()]);
        if(empleadosResponse?.ok && empleadosResponse?.payload){
            setEmpleados(empleadosResponse.payload);
        }
        if(rolesResponse?.ok && rolesResponse?.payload){
            const options = rolesResponse.payload
                .filter((item) => item?.id > 0)
                .map((item) => ({ value: item.id, label: item.name }))
                .sort((a, b) => a.value - b.value);
            setRoles(options);
            if (options.length > 0) {
                const preferred = options.find((option) => option.value === 1) || options[0];
                setRole(preferred.value);
            }
        }
    }

    const closeFn = () => {
        setShowModal(false);
    }

    return <>
        <Button type="primary" onClick={btnClick}>
            Agregar Usuario
        </Button>
        {
            showModal ?
                <Modal open={true} title="Agregar Usuario" closeFn={closeFn} buttons={[
                    <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                        Guardar
                    </Button>,
                ]}>
                    <Row>
                        <Col md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}>
                            <Label>Correo Electrónico</Label>
                            <Input value={email} defaultValue={email} onChange={(event) => { setEmail(event.target.value) }} size="middle" />
                        </Col>
                        <Col md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}>
                            <Label>Nombre</Label>
                            <Input value={firstName} defaultValue={firstName} onChange={(event) => { setFirstName(event.target.value) }} size="middle" />
                        </Col>
                        <Col md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}>
                            <Label>Apellidos</Label>
                            <Input value={lastName} defaultValue={lastName} onChange={(event) => { setLastName(event.target.value) }} size="middle" />
                        </Col>
                        <Col md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}>
                            <Label>Password</Label>
                            <Input.Password value={password} defaultValue={password} onChange={(event) => { setPassword(event.target.value) }} size="middle" />
                        </Col>

                        <Col md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}>
                            <Label>Rol</Label>
                            <Select
                                style={{ minWidth: 200 }}
                                value={role}
                                onChange={handleChangeRole}
                                options={roles}
                                placeholder="Selecciona un rol"
                            />
                        </Col>

                        <Col md={{ span: 22, offset: 1 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}>
                            <Label>Empleado (Opcional)</Label>
                            <Select
                                style={{ minWidth: 200 }}
                                value={empleado}
                                onChange={setEmpleado}
                                allowClear
                                placeholder="Seleccionar empleado"
                                options={empleados?.map(emp => ({
                                    value: emp.value,
                                    label: emp.text
                                })) || []}
                            />
                        </Col>
                    </Row>
                </Modal> : <></>
        }

    </>
}
export default AddUser;
